import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../lib/utils"

const textareaVariants = cva(
  "flex w-full bg-white text-sm text-gray-900 placeholder:text-gray-400 transition-colors disabled:cursor-not-allowed disabled:opacity-50 outline-none",
  {
    variants: {
      variant: {
        default:
          "border border-black rounded-lg px-3 py-2 shadow-sm focus:ring-2 focus:ring-primary/20 focus:border-primary",
        outline:
          "border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-primary/20 focus:border-primary",
        ghost:
          "border-none bg-transparent px-0 py-2 focus:ring-0",
      },
      textareaSize: {
        default: "min-h-[96px]",
        sm: "min-h-[72px] text-xs px-2",
        lg: "min-h-[140px] text-base px-4",
      },
    },
    defaultVariants: {
      variant: "default",
      textareaSize: "default",
    },
  }
)

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    VariantProps<typeof textareaVariants> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, variant, textareaSize, ...props }, ref) => (
    <textarea
      className={cn(textareaVariants({ variant, textareaSize, className }))}
      ref={ref}
      {...props}
    />
  )
)
Textarea.displayName = "Textarea"

export { Textarea, textareaVariants }
